
import React, {useEffect, useState} from 'react';

function App() {  
    const [history, setHistory] = useState(); 
         useEffect(() => {
            let url = "./configs/history.json";
            fetch(url)
                .then(res => res.json())
                .then(json => setHistory(json))
            }, []);

    return (
        history!=undefined?
        <div className="component-view animate" data-animate="blendin 3s">
       
        
            
               {/*  <div className=" text-center text-header">
                    {history.header}
                </div> */}

                {
                    history.content.map(item =>(
                        <div className="text-item text-block" > 
                        {item}
                        </div> 
                    ))
                }

               
            
         
        </div>:null
    );
}
    
    export default App;